import React, { useRef } from 'react'
import FieldItemList from '../FieldItemList'
import { useQueryLayout, VIEW_TYPE } from '../../hooks/useQueryLayout'
import styles from './index.less'

const InlineFieldsList = ({ fields }) => {
    return (
        <div>
            <FieldItemList showLabel showBtn={false} fieldsList={fields} colStyle={{ width: 'auto' }} />
        </div>
    )
}

const FieldsList = ({ fields }) => {
    const widthRef = useRef(null)

    const { fields: fieldsList } = useQueryLayout(fields, {
        hasButton: false,
        widthRef
    })

    return (
        <div ref={widthRef}>
            <FieldItemList showLabel showBtn={false} fieldsList={fieldsList} />
        </div>
    )
}

export default ({ fields }) => {
    if (!fields?.length) {
        return null
    }

    return fields.map(item => {
        if (item.viewType === VIEW_TYPE.INLINE) {
            return <InlineFieldsList key={item.key} fields={item.fields} />
        }

        return (
            <React.Fragment key={item.key}>
                <FieldsList fields={item.fields} />

                {
                    item.afterBorder ? <div className={styles.line} /> : null
                }
            </React.Fragment>
        )
    })
}
